export default {
  state: {
    assemblyArticles: null
  },
  mutations: {
    setAssemblyArticles(state, payload) {
      state.assemblyArticles = payload;
    }
  },
  actions: {
    setAssemblyArticles({ commit }, payload) {
      commit("setAssemblyArticles", payload);
    }
  },
  getters: {
    assemblyArticles(state) {
      return state.assemblyArticles;
    }
  }
};
